import truncate from 'lodash/truncate';

import { UserType } from '../constants/user.constants';

export const getUserRole = user => {
  const t = user?.userType;
  if (t === UserType.OWNER) return 'Owner';
  if (t === UserType.VIEWER) return 'Viewer';
  return 'Editor';
}

export const getUserDisplayName = (user, truncateAt = 48) => {
  const result = user?.email || user?.username || 'Removed User';

  return truncate(result, {
    length: truncateAt,
    separator: /([.@\s])+/,
  });
};
